import { root as CampaignSagas } from './campaign';
import { root as CommunicationSagas } from './communication';
import { root as TemplateSagas } from './template';
import { root as UserSagas } from './user';
import { root as AttachmentTemplateSagas } from './attachmentTemplate';
import { root as QueryTemplateSagas } from './recipientQueryTemplate';
import { root as ConditionQueryTemplateSagas } from './conditionQueryTemplate';
import { root as PrintTemplateSagas } from './printTemplate';
import { root as SurveyTemplateSagas } from './surveyTemplate';
import { root as Surveys } from './surveys';
import { root as Settings } from './settings';
import { root as Events } from './event';
import { root as Reports } from './reports';
import { root as eventReports } from './eventReports';
import { root as batches } from './batches';
import { root as unSubscribe } from './unSubscribe';
import { root as Schema } from './schema';
import { root as EnrichedSchema } from './enrichedSchema';
import { root as Lists } from './lists';
import { root as guestInsights } from './guestInsights';
import { sagas as CopyTemplateModalSagas } from './copyTemplateModal';
import { root as SurveyAi } from './surveyAi';
import { root as Uploads } from './uploads';

export default [
  ...CampaignSagas,
  ...CommunicationSagas,
  ...TemplateSagas,
  ...UserSagas,
  ...AttachmentTemplateSagas,
  ...QueryTemplateSagas,
  ...ConditionQueryTemplateSagas,
  ...PrintTemplateSagas,
  ...SurveyTemplateSagas,
  ...Surveys,
  ...Settings,
  ...Reports,
  ...eventReports,
  ...batches,
  ...unSubscribe,
  ...Events,
  ...Schema,
  ...EnrichedSchema,
  ...Lists,
  ...guestInsights,
  ...CopyTemplateModalSagas,
  ...SurveyAi,
  ...Uploads
];
